// Live GraphQL operation for the AWS AI Cost Trends summary widget
// (consumed by both the budget-owner view AWSAICostTrends.tsx and the
// FA view AWSAICostTrendsFA.tsx). Plain backtick template so it works
// with the codebase's GraphQLClient.request({ query }) signature —
// matches the convention used by the existing src/ts/modules/<module>/
// repo/graphql/*.ts query files (see listAIGovernanceTasks,
// listFoundationModels). The fileliveshere per the chunk spec.
export const GET_AI_SPEND_TRENDS = `
  query GetAISpendTrends($days: Int) {
    getAISpendTrends(days: $days) {
      budgetId
      budgetName
      serviceCode
      serviceName
      days
      totalClaimed
      totalShared
      totalCost
      deltaPercent
      isNew
      tokens
    }
  }
`
